/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .controller('ShareGroupsModal', [
        '$modalInstance',
        '$scope',
        'operationComplete',
        'shareGroup',
        'ShareGroupsResource',
        function (
            $modalInstance,
            $scope,
            operationComplete,
            shareGroup,
            ShareGroupsResource
        ) {
            $scope.modal = $modalInstance.options;
            $scope.close = $scope.cancel = () => $modalInstance.dismiss('cancel');

            $scope.isUpdating = shareGroup != null;
            $scope.isCurrentUserGroupOwner = $scope.isUpdating ? shareGroup.isCurrentUserGroupOwner : true;
            $scope.groupModel = {
                ...($scope.isUpdating ? { uuid: shareGroup.uuid } : {}),
                name: $scope.isUpdating ? shareGroup.name : '',
                description: $scope.isUpdating ? shareGroup.description : ''
            };
            $scope.FORBIDDEN_GROUP_NAME_SYMBOLS = '@';
            $scope.groupNameRegexp = new RegExp(`^[^${$scope.FORBIDDEN_GROUP_NAME_SYMBOLS}]*$`);

            Object.defineProperties($scope, {
                canSubmit: {
                    get: () => $scope.groupModel.name && $scope.groupModel.name.length > 0
                },
                descriptionLabel: {
                    value: $scope.isCurrentUserGroupOwner ?
                        'share_groups_create_group_modal_input_description' :
                        'share_groups_view_group_modal_input_description'
                },
                descriptionPlaceholder: {
                    value: $scope.isCurrentUserGroupOwner ?
                        'share_groups_create_group_modal_input_description_placeholder' :
                        'share_groups_view_group_modal_input_description_empty_placeholder'
                },
                submitButtonLabel: {
                    value: $scope.isUpdating ?
                        'share_groups_manage_group_modal_btn_save' :
                        'share_groups_create_group_modal_btn_create'
                },
                closeButtonLabel: {
                    value: $scope.isCurrentUserGroupOwner ?
                        'share_groups_create_group_modal_btn_cancel' :
                        'Close'
                },
                isEveryoneGroup: {
                    get: () => shareGroup.everyone
                },
                ownerEmail: {
                    value: $scope.isUpdating && shareGroup.owner ?
                        shareGroup.owner.email :
                        ''
                }
            });

            $scope.onFormSubmit = () => {
                const request = $scope.isUpdating ? ShareGroupsResource.update : ShareGroupsResource.save;

                $scope.modal.loading = true;

                return request($scope.groupModel).$promise
                    .then((group) => {
                        const successString = $scope.isUpdating ?
                            'share_groups_manage_group_success_message' :
                            'share_groups_create_group_success_message';

                        operationComplete(successString);
                        $modalInstance.close(!$scope.isUpdating ? group : null);
                    })
                    .finally(() => $scope.modal.loading = false);
            }
        }
    ]);
